import specsSearch from '../../components/specsSearch';

document.querySelectorAll('form.specs-search__form')
  .forEach(el => new specsSearch(el));
